<template>
  <n-config-provider
    :theme="theme.naiveTheme"
    :theme-overrides="theme.naiveThemeOverrides"
    :locale="naiveUILocale[locale.locale].locale"
    :date-locale="naiveUILocale[locale.locale].dateLocale"
    :hljs="hljs"
    class="h-full"
  >
    <naive-provider>
      <router-view />
      <n-watermark
        :content="authStore.watermark"
        cross
        fullscreen
        font-family="Vedana"
        :font-size="15"
        :font-color="theme.darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.15)'"
        :width="300"
        :height="280"
        :y-offset="140"
        :rotate="-28"
        :z-index="100000"
      />
      <draggable-modal-wrapper />
      <screen-lock />
    </naive-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { zhCN, dateZhCN, plPL, datePlPL, thTH, dateThTH, viVN, dateViVN, dateEnUS } from 'naive-ui';
import hljs from 'highlight.js/lib/core';
import _json from 'highlight.js/lib/languages/json';
import { subscribeStore, useThemeStore, useLocaleStore, useAuthStore } from '@/store';
import { useGlobalEvents } from '@/composables';
import { myMM } from '@/locales/naive-ui';
import { ScreenLock } from '@/components/business/lockscreen';

hljs.registerLanguage('json', _json);

const naiveUILocale = {
  'zh-CN': {
    locale: zhCN,
    dateLocale: dateZhCN
  },
  pl_PL: {
    locale: plPL,
    dateLocale: datePlPL
  },
  th_TH: {
    locale: thTH,
    dateLocale: dateThTH
  },
  vi_VN: {
    locale: viVN,
    dateLocale: dateViVN
  },
  my_MM: {
    locale: myMM,
    dateLocale: dateEnUS
  }
};

const theme = useThemeStore();
const locale = useLocaleStore();
const authStore = useAuthStore();

subscribeStore();
useGlobalEvents();
</script>

<style scoped></style>
